<template>
  <div>

    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">Print Fields</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="fn_new" v-if="createNew"><v-icon>add</v-icon></v-btn>
      <!-- <v-btn icon @click="fn_getBottomMenu(901)"><v-icon>more_vert</v-icon></v-btn> -->

      <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    </v-toolbar>

    <div class="display_msg" v-if="!filteredItems.length">No Items</div>

    <div style="background-color:#F0F0F0;" class="hasToolbar hasExtension">
      <v-list nopadding>
        <div v-for="(item, index) in filteredItems" :key="index">
          <v-list-tile>
            <v-list-tile-content @click="fn_itemClick(item)">
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
            </v-list-tile-content>
            <!-- <v-list-tile-action>
                <v-btn icon flat @click="fn_getBottomMenu(902, item.fieldId, item.isSystem)"><v-icon>more_vert</v-icon></v-btn>
              </v-list-tile-action> -->
          </v-list-tile>
          <v-divider v-if="filteredItems.length-1 != index"></v-divider>
        </div>
      </v-list> 
    </div>
  </div>
</template>

<script>
var tagId = null;
const menuItem = require('../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../config.js').configs.bottomSheetMenu;
import {masterMixin} from '../masters/master_mixin.js'

  export default{
    mixins: [masterMixin],
    data(){
      return{
        listItems:[],
        searchValue:'',
        scrollPositionTop:0,
        selectedItemId:null,
        createNew:false
      }
    },
    methods:{
      fn_new: function () {
        let parentId = this.$route.query.parentId ? this.$route.query.parentId : null;
        this.$router.push({path:"/printfield/items/new", query:{tagId:this.guidWeb(), parentId:parentId}});
      },

      fn_goBack: function(){
        this.$router.go(-1);
      },

      fn_menuItemClick: function(tagId, menuId, menuAction){
        // tagId id form future use
        // menuId id form future use
        if(menuAction=='new'){
          this.fn_new();
        }
        else if(menuAction=='edit'){
          this.$router.push("/fields/"+this.selectedItemId+"/edit");
        }
        else if(menuAction=='copy'){
          this.$router.push({path:'/fields/new', query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
        }
        // else if(menuAction=='delete'){
        //   let itemIndex = this.listItems.findIndex(item=>{
        //     return item.fieldId == this.selectedItemId;
        //   })

        //   let self = this;
        //   this.fn_deleteMasterItem('fields', this.selectedItemId, function(response){
        //     if(response){
        //         self.showToast('Item deleted');
        //         itemIndex != -1 ? self.listItems.splice(itemIndex, 1) : '';
        //     }
        //     else{
        //         self.showToast("Item cannot be deleted as already in use");
        //     }
        //   })
        // }
      },

      fn_itemClick: function (item) {
        // tagId id form future use
        // itemName id form future use
        if(item.isParent){
          this.$router.push({path:"/printfield/items", query:{new:false, parentId:item.fieldId}});
        }
        else{
          this.$router.push({path:"/printfield/items/"+item.fieldId+"/edit", query:{disableName: this.createNew ? false : true}});
        }
      },

      // fn_getBottomMenu: function (elementId, itemId, isSystem) {

      //   let bottomMenu = null;

      //   if(elementId == bottomSheetMenu.toolBar.Id){
      //     bottomMenu = {"BottomMenu": [menuItem.help]};
      //   }
      //   else if(elementId == bottomSheetMenu.masterListItems.Id){
      //     bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]};
      //     !Number(isSystem) ? bottomMenu.BottomMenu.push(menuItem.delete) : '';
      //     this.selectedItemId = itemId;
      //   }

      //   this.setBottomMenu(tagId, bottomMenu, 
      //     {
      //       onSuccess: function (response) {
      //         console.log(response);
      //       },
      //       onError: function (error) {
      //         console.log(error);
      //       }
      //     }
      //   )
      // },


      fn_getItems: function () {
        let filterObject = {};
        filterObject.groupTypeId = 102;
        filterObject.parentId = this.$route.query && this.$route.query.parentId ? this.$route.query.parentId : null;
        // filterObject.limit = 10;
        // filterObject.startIndex = this.startIndex;
        // filterObject.search = this.searchValue.toLowerCase();

        let self = this;
        this.getItems("FieldList", filterObject, 
          {
            onSuccess: function (response) {
              console.log(response);
              self.listItems = JSON.parse(response);
              // for(let i=0; i<self.listItems.length; i++){
              //   self.listItems[i].fieldType = JSON.parse(self.listItems[i].fieldType)
              // }
            },
            onError: function (error) {
              console.log(error);
            }
          }
        )
      },

      fn_showWebView: function () {
        var viewObject = {};
        var self = this;
        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null,
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            } 
          }
        );
      },
    },
    mounted: function () {
      // tagId = this.$route.query.tagId;
      this.createNew = JSON.parse(this.$route.query.new);
      this.fn_showWebView();
      this.fn_getItems();
      window.js_globals.fn_onBackPress = this.fn_goBack;

      let self = this;
      document.addEventListener('scroll', function () {
        self.scrollPositionTop = window.pageYOffset
      })
    },
    computed:{
      filteredItems: function () {
        let searchText = this.searchValue.toLowerCase();

        return this.listItems.filter(item => {
          let fieldItem = item.name.toLowerCase();
          return fieldItem.match(searchText);
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/print_fields/items.vue